import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import chauffeurImg from "../images/julien.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faStar,
  faCar,
  faMugHot,
  faPhone,
  faEnvelope,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

export default function ChauffeurSection() {
  return (
    <section className="chauffeur-section py-5 text-white">
      <Container>
        <h2 className="section-title text-center mb-5">Votre Chauffeur</h2>

        <Row className="align-items-center">
          {/* Photo */}
          <Col lg={5} className="mb-4 mb-lg-0 text-center">
            <div className="chauffeur-photo-wrapper">
              <img
                src={chauffeurImg}
                alt="Julien Mondon"
                className="chauffeur-photo rounded shadow-lg"
              />
            </div>
          </Col>

          {/* Texte */}
          <Col lg={7}>
            {/* Phrase d'accroche */}
            <p className="chauffeur-quote">
              <span className="quote-mark">“</span>À chaque course, je veille
              personnellement à votre confort et à votre ponctualité.
              <span className="quote-mark">”</span>
            </p>

            {/* Infos chauffeur */}
            <div className="chauffeur-infos mt-3">
              <p className="mb-2">
                <FontAwesomeIcon icon={faUser} className="me-2" />
                Julien Mondon
              </p>
              <p className="mb-2">
                <FontAwesomeIcon icon={faPhone} className="me-2" />
                06 26 65 25 39
              </p>
              <p className="mb-2">
                <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                azurpacavtc@gmail.com
              </p>
            </div>

            {/* Icônes services */}
            <div className="chauffeur-icons mt-4 d-flex gap-4 justify-content-start flex-wrap">
              <div className="icon-item text-center">
                <FontAwesomeIcon icon={faClock} size="2x" />
                <p className="mt-2 mb-0">Ponctualité</p>
              </div>
              <div className="icon-item text-center">
                <FontAwesomeIcon icon={faStar} size="2x" />
                <p className="mt-2 mb-0">Service Premium</p>
              </div>
              <div className="icon-item text-center">
                <FontAwesomeIcon icon={faCar} size="2x" />
                <p className="mt-2 mb-0">Confort & Sécurité</p>
              </div>
              <div className="icon-item text-center">
                <FontAwesomeIcon icon={faMugHot} size="2x" />
                <p className="mt-2 mb-0">En-cas & boissons</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
